module.exports = __webpack_public_path__ + "img/mobile/BetBar/btn-betland-up@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/BetBar/btn-betland-up@1x.png
// module id = 599
// module chunks = 0